import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-flex tw-h-full tw-items-center tw-justify-center tw-px-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HlsPlayer = _resolveComponent("HlsPlayer")!
  const _component_StudioDialog = _resolveComponent("StudioDialog")!

  return (_openBlock(), _createBlock(_component_StudioDialog, {
    title: _ctx.videoAsset.name,
    size: "large",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_HlsPlayer, {
          class: "play-video-body",
          videoStreamUrl: _ctx.videoAsset.urls?.hls
        }, null, 8, ["videoStreamUrl"])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}